// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import ElementUI from 'element-ui'
// 此处后续替换为修改过样式
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import ajax from '@/services/ajax'
import request from '@/services/request'
import INTERFACE from './interface'
import config from './config'
import '@/style/all.styl'
import './assets/common/css/pages.css'
import Es6Promise from 'es6-promise'
import locale from 'element-ui/lib/locale/lang/en'

Es6Promise.polyfill()
// mock 启动
// if (/localhost/.test(location.href)) {
require('@/mock');
// }

// 设置请求头
request.init()

// 插件配置
// Vue.use(ElementUI)
Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

// 全局变量
window.localStorage.permissionCheckUrl = 'platform/v1/access/resources'
window.localStorage.defaultLanguage = 'EN_US'

// 动态设置环境
console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === 'development') {
  // dev环境
  window.localStorage.gatewayDomain = 'https://dev-api.zjlh.lan/'
  window.localStorage.serviceName = 'https://dev-hg-apply-thirdparty.zjlh.lan'
} else if (process.env.NODE_ENV === 'stag') {
  // stag预发布环境
  window.localStorage.gatewayDomain = 'https://stag-api.gc-life.cn/'
  window.localStorage.serviceName = 'https://stag-hg-apply-thirdparty.gc-life.cn'
} else if (process.env.NODE_ENV === 'production') {
  // 生产环境
  window.localStorage.gatewayDomain = 'https://api.gc-life.com/'
  window.localStorage.serviceName = 'https://bmp-hg-apply-thirdparty.gc-life.com'
}
console.log(window.localStorage.gatewayDomain)

// axios 统一配置
ajax.init()

config.init()

// 此处调用国际化接口，获取国际化数据
INTERFACE.getI18nType().then((data) => {
  INTERFACE.getI18n(data.type).then(() => {
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      template: '<App/>',
      components: {App}
    })
  })
})



// WEBPACK FOOTER //
// ./src/main.js